import { node, oneOfType, string } from "prop-types";
import { useMemo } from "react";

import FnrTypography from "UI/FnrTypography";
import { useIsDark, useIsLegacy } from "Login/TwoFA/stateHooks";

const PromptTypography = ({ children, ...rest }) => {
  const isLegacy = useIsLegacy();
  const isDark = useIsDark();

  const color = useMemo(() => {
    if (isDark) return "textLight";
    if (isLegacy) return "textBlack";
    return "brandFnBlue";
  }, [isDark, isLegacy]);

  return (
    <FnrTypography
      type={isLegacy ? undefined : "subheader"}
      color={color}
      fontSize="lg"
      {...rest}
    >
      {children}
    </FnrTypography>
  );
};

PromptTypography.propTypes = { children: oneOfType([string, node]) };

export default PromptTypography;
